module.exports = __webpack_public_path__ + "SourceSansPro-SemiBold.db3c2763714367298b44.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/SourceSansPro-SemiBold.ttf
// module id = ../../../../../src/assets/customfonts/SourceSansPro-SemiBold.ttf
// module chunks = styles